import { isDirty, isSubmitting, hasSubmitFailed, hasSubmitSucceeded } from 'redux-form';

export const submitting = (formName) => (state) => {
	return isSubmitting(formName)(state);
};

export const submitFailed = (formName) => (state) => {
	return hasSubmitFailed(formName)(state);
};

export const submitSucceeded = (formName) => (state) => {
	return hasSubmitSucceeded(formName)(state);
};

export const hasChangedForms = (formNames) => (state) => {
	return formNames.some((f) => isDirty(f)(state));
};
